var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"stepWrap",staticClass:"step-wrap"},[_c('div',{staticClass:"step-btn",on:{"click":function($event){return _vm.changeVal('+')}}},[_vm._v("+")]),_c('div',{staticClass:"step-val"},[_vm._v(_vm._s(Math.floor(_vm.val * 100) / 100))]),_c('div',{staticClass:"step-btn",on:{"click":function($event){return _vm.changeVal('-')}}},[_vm._v("-")])])
}
var staticRenderFns = []

export { render, staticRenderFns }